import React from "react";
// reactstrap components
import { Container} from "reactstrap";

class HeaderEmpty extends React.Component {
  render() {
    return (
      <>
        <div className="header bg-gradient-info">
          <Container fluid>
            <div className="header-body">
              
            </div>
          </Container>
        </div>
      </>
    );
  }
}

export default HeaderEmpty;
